import { createContext } from 'react';

/**
 * Whether the settings panel is open. The page behind it renders against a
 * location of its own, so the router there reports that page, not the URL.
 */
export const SettingsOpenContext = createContext(false);
